module.exports = __webpack_public_path__ + "static/media/mail_icon.34ba4b61.svg";